export function Memoize(): MethodDecorator {
    return function memoizeDecorator(target: Object, propertyKey: string | symbol,
        propertyDescriptor: TypedPropertyDescriptor<any>): TypedPropertyDescriptor<any> | void {
        if (!propertyDescriptor || !propertyDescriptor.get)
            return;

        let fieldName = `_${propertyKey}.memoized`
        return {
            configurable: false,
            get: function () {
                if (this[fieldName] === undefined)
                    this[fieldName] = propertyDescriptor.get.call(this);

                return this[fieldName];
            },
            set: propertyDescriptor.set ? function (value: any) {
                this[fieldName] = undefined;
                propertyDescriptor.set.call(this, value);
            } : function (_) {
                this[fieldName] = undefined;
            }
        };
    }
}

export function LocalStorage(storageKey: string, backingfieldname?: string): MethodDecorator {
    return function localStorageDecorator(target: Object, propertyKey: string | symbol,
        propertyDescriptor: TypedPropertyDescriptor<any>): TypedPropertyDescriptor<any> | void {
        if (!propertyDescriptor || !propertyDescriptor.get)
            return;
        var cached = localStorage[storageKey];
        if (cached !== undefined){
            if(backingfieldname)
                target[backingfieldname] = JSON.parse(cached);
            else if(propertyDescriptor.set)
                propertyDescriptor.set.call(target, JSON.parse(cached));
        }

        var cacheValue = (value) => {
            if (value === null || value === undefined)
                localStorage.removeItem(storageKey);
            else
                localStorage[storageKey] = JSON.stringify(value);
        }

        var result: TypedPropertyDescriptor<any> = {
            configurable: false,
            get: function () {
                var value = propertyDescriptor.get.call(this);
                cacheValue(value);
                return value;
            }
        };
        if (propertyDescriptor.set)
            result.set = function (value: any) {
                cacheValue(value)
                propertyDescriptor.set.call(this, value);
            }
        return result;
    }
}